import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider, CssBaseline, Box } from "@mui/material";
import theme from "./theme/theme";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import ServicesPage from "./pages/ServicesPage";
import TemoignagesPage from "./pages/TemoignagesPage";
import LocationLingePage from "./pages/Locationlingepage";
import BlanchisseriePage from "./pages/BlanchisseriePage";
import ContactPage from "./pages/ContactPage";
import TapisPage from "./pages/TapisPage";

const Layout = ({ children }) => (
  <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
    <Navbar />
    <Box component="main" sx={{ flexGrow: 1 }}>
      {children}
    </Box>
    <Footer />
  </Box>
);

const App = () => (
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/location-linge" element={<LocationLingePage />} />
          <Route path="/services/blanchisserie" element={<BlanchisseriePage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/services/tapis" element={<TapisPage />} />
          <Route path="/services/:slug" element={<ServicesPage />} />
          <Route path="/temoignages" element={<TemoignagesPage />} />
        </Routes>
      </Layout>
    </BrowserRouter>
  </ThemeProvider>
);

export default App;